import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="font-mono text-xs text-[var(--span-text-2)]">AUTHENTICATING…</div>
      </div>
    );
  }
  if (!user || user === false) return <Navigate to="/login" replace />;
  return children;
}
